import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceBase } from '@shared-services/service-base.service';

@Injectable()
export class FormGroupOptionService extends ServiceBase {  
    constructor(http: HttpClient) { 
        super(http);
    } 
}